<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER">账户常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">海星云有哪些免费游戏</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>海星云有哪些免费游戏?
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <br />1.The Witcher 3: Wild Hunt (巫师3：狂猎)
              <br />2.ARK:Survival Of The Fittest (方舟：生存进化)
              <br />3.Battlerite (战争仪式)
              <br />4.Cities:SKylines (城市:天际线)
              <br />5.CS GO 6.Crossout (创世战车)
              <br />6.DISco Elysium (极乐迪斯科)
              <br />7.Door Kickers (破门而入)
              <br />8.Dota 2
              <br />9.Dota Underlords (刀塔霸业)
              <br />10.The Forest (森林)
              <br />11.GTFO
              <br />12.Half-Life (半条命)
              <br />13.Half-Life 2 (半条命2)
              <br />14.Heroes & Generals (英雄与将军)
              <br />15.Injustice 2 (不义联盟2)
              <br />16.Kenshi (剑士)
              <br />17.Kingdom Come：Deliverance (天国：拯救)
              <br />18.Left 4 Dead 2 (求生之路2)
              <br />19.Middle-earth:Shadow of War (中土世界：暗影之争)
              <br />20.MORDHAU (血腥剑斗)
              <br />21.Night of the Dead (死亡之夜)
              <br />22.PC Building Simulator (装机模拟器)
              <br />23.Planetbaes (星球基地)
              <br />24.Portal 2 (传送门2)
              <br />25.RimWorld (环世界)
              <br />26.Robocraft (罗博造造)
              <br />27.Space Engineers (太空工程师)
              <br />28.SUPERHOT (燥热)
              <br />29.Terraria (泰拉瑞亚)
              <br />30.Thief Simulator (小偷模拟器)
              <br />31.Three Kingdoms: The Last Warlord (三国志：汉末霸业)
              <br />32.Trine 3:The Artifacts of Power (三位一体：权利圣器)
              <br />33.Trove (宝藏世界)
              <br />34.Unrailedl (一起开火车)
              <br />35.Unturned (未转变者)
              <br />36.War Thunder (战争雷霆)
              <br />37.Warframe (星际战甲)
              <br />38.Warhammer : Vermintide 2 (战锤：末日鼠疫)
              <br />39.Witch It (女巫来了)
              <br />40.The WITCHER 2:Assassins of Kings (巫师2：刺客之王)
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./Account')
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.da {
  font-size: 16px;
  margin-bottom: 10px;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/Account/free.vue